<template>
  <div v-if="props.assetVisit.vehicleObservations">
    <key-value-list variant="list" size="small" v-if="hasObservationData">
      <key-value label="License plate" :value="licensePlate" />
      <key-value label="DOT" :value="dotNumber" />
      <key-value label="Load number" :value="loadNumber" />
      <key-value label="Trailer type" :value="trailerType" />
    </key-value-list>
    <div v-else>
      <span class="text-caption" v-if="isPending">
        {{ t('assetVisit.components.navtracObservationData.messages.scanningPending') }}
      </span>
      <span class="text-caption" v-else>
        {{ t('assetVisit.components.navtracObservationData.messages.noDetailsCouldBeAdded') }}
      </span>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { get } from 'lodash';
import { useI18n } from 'vue-i18n';
import { isObservationMatchPending } from '@/utils';

const props = defineProps({
  observationEventMatchTimeWindow: {
    type: Number,
    default: () => 0,
    required: true
  },
  assetVisit: {
    type: Object,
    default: () => ({}),
    required: true
  }
});

const { t } = useI18n();
const vehicleObservations = computed(() => get(props, 'assetVisit.vehicleObservations.0'));
const assetObservations = computed(() =>
  get(props, 'assetVisit.vehicleObservations.0.assetObservations')
);

const isPending = computed(() =>
  isObservationMatchPending(props.assetVisit.createDateTime, props.observationEventMatchTimeWindow)
);

const licensePlate = computed(() => {
  return vehicleObservations.value?.licensePlate || '-';
});

const dotNumber = computed(() => {
  return vehicleObservations.value?.dotNumber || '-';
});

const trailer = computed(() =>
  assetObservations.value?.find(asset => asset.assetType !== 'Chassis')
);

const loadNumber = computed(() => {
  return trailer.value?.number || '-';
});

const trailerType = computed(() => {
  return trailer.value?.assetType || '-';
});

const hasObservationData = computed(() => {
  return vehicleObservations.value || assetObservations.value;
});
</script>
